import { ref, computed } from "vue";

import { type Table } from "@tanstack/vue-table";

export const useColumnOrder = <T>(table: Table<T>) => {
  const columnsToggleList = computed(() => {
    return table.getAllLeafColumns().filter((column) => column.getCanHide());
  });

  const draggedItemIndex = ref<null | number>(null);
  const targetItemIndex = ref<null | number>(null);

  const moveItem = (
    array: string[],
    fromIndex: number,
    toIndex: number,
  ): string[] => {
    const item = array[fromIndex];
    const newArray = [
      ...array.slice(0, fromIndex),
      ...array.slice(fromIndex + 1),
    ];

    return [...newArray.slice(0, toIndex), item, ...newArray.slice(toIndex)];
  };

  const onDrop = (index: number) => {
    const items = ref(
      Object.values(columnsToggleList.value).map((column) => column.id),
    );

    if (draggedItemIndex.value === null || !items.value) {
      return;
    }

    targetItemIndex.value = null;

    items.value = moveItem(items.value, draggedItemIndex.value, index);
    table.setColumnOrder(items.value);
  };

  const onDragEnter = (index: number) => {
    if (index === draggedItemIndex.value) {
      return;
    }
    targetItemIndex.value = index;
  };

  const onDragStart = (event: DragEvent, item: number) => {
    if (!event.dataTransfer) {
      return;
    }
    event.dataTransfer.effectAllowed = "move";
    draggedItemIndex.value = item;
  };

  const onDragEnd = () => (targetItemIndex.value = null);

  return {
    targetItemIndex,
    onDrop,
    onDragEnter,
    onDragStart,
    onDragEnd,
  };
};
